import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { alVencerSesion } from '@renderer/lib/sesionVencida';
import { useSessionStore } from '@renderer/store/useSessionStore';

/**
 * Sprint 156 — "Cierra el sistema y vuelve a entrar", pero dicho por el sistema.
 *
 * La sesión dura doce horas y no se renueva sola: en un turno largo se vence con
 * el negocio abierto. Hasta aquí nadie lo decía — las acciones empezaban a fallar
 * con mensajes que no tenían nada que ver, y la impresión en particular se
 * disfrazaba de "no hay impresora". La dueña descubrió por su cuenta que cerrar y
 * volver a entrar lo arreglaba, sin saber nunca por qué.
 *
 * Es de las pocas cosas que SÍ merecen interrumpir: a partir de ese momento nada
 * de lo que haga se va a guardar. Dejarla cobrando contra una sesión muerta es
 * peor que detenerla diez segundos.
 */
export function AvisoSesionVencida() {
  const navigate = useNavigate();
  const setSesion = useSessionStore((s) => s.setSesion);
  const [visible, setVisible] = useState(false);

  useEffect(() => alVencerSesion(() => setVisible(true)), []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-900/60 p-4"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="titulo-sesion-vencida"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <div className="flex items-start gap-3">
          <KeyRound className="mt-1 h-8 w-8 shrink-0 text-amber-600" aria-hidden />
          <div>
            <h2 id="titulo-sesion-vencida" className="text-xl font-bold text-slate-900">
              Tu sesión se cerró
            </h2>
            <p className="mt-2 text-base text-slate-700">
              Por seguridad, el sistema pide tu clave otra vez después de varias horas. Vuelve a
              entrar; las ventas que ya estaban guardadas siguen ahí.
            </p>
          </div>
        </div>
        <button
          onClick={() => {
            setVisible(false);
            setSesion(null);
            navigate('/login');
          }}
          className="mt-5 min-h-[44px] w-full rounded-lg bg-primary px-4 py-3 text-base font-bold text-primary-fg hover:brightness-95"
        >
          Entrar de nuevo
        </button>
      </div>
    </div>
  );
}
